import React,{ useState} from 'react';
import { Button, Icon } from 'semantic-ui-react';
import {useHistory} from "react-router-dom"
import {  useApolloClient } from '@apollo/client';
import ComfirmDeletePublic from '../SetingPublic/DeletePublication/ConfirmDelete/ComfirmDeletePublic';
import ModalBasic from '../../../ModalBasic';
import Ofert from "./Ofert"

import DescriptionForm from "../SetingPublic/DescriptionForm"
import Titul from "../SetingPublic/Titul"
import Whasapchange from "../SetingPublic/Whasapchange"
import Video from "../SetingPublic/Video"
import Market from "../SetingPublic/Market"
import Mercado from "../SetingPublic/Mercado"


import "./SetingPublic.scss";


export default function SetingPublic(props) {
    const {publication ,setShowModal , setTitleModal, setChildrenModal  ,refetch } = props;
    const history = useHistory ();
    //const client = useApolloClient ();
    //console.log (publication)

   const Promo = () =>  {
      setTitleModal("Baja el precio para Promocionar 😬 ");
      setChildrenModal(< Ofert  publication={publication} setShowModal={setShowModal} />);
     
    };

    const titulo = () => {
    setTitleModal ("Actualiza el titulo ");
    setChildrenModal (< Titul publication={publication} setShowModal={setShowModal} />)
    }

    const Descripcion = () => {
      setTitleModal( "Actualiza el titulo de tu articulo ");
      setChildrenModal (<DescriptionForm publication={publication} setShowModal={setShowModal} /> );
      
    }
     
    const Marcar = () => {
      setTitleModal ("Numero de whats App");
      setChildrenModal (< Whasapchange publication={publication} setShowModal={setShowModal} />  )
    }

    const Eliminar = () => {
      setTitleModal( "Borra tu publicacion 🗑️ ");
      setChildrenModal (<ComfirmDeletePublic publication={publication}  setShowModal={setShowModal} /> );
      
    }

    const Vide = () => {
      setTitleModal( "Ingresa el codigo del video  ");
      setChildrenModal (<Video publication={publication}  setShowModal={setShowModal} /> );
      
    }


    const Maket = () => {
      setTitleModal( "Ingresa el enlace de la publicacion  ");
      setChildrenModal (<Market publication={publication}  setShowModal={setShowModal} /> );
      
    }

    const Merca = () => {
      setTitleModal( "Ingresa el enlace de la publicacion  ");
      setChildrenModal (<Mercado publication={publication}  setShowModal={setShowModal} /> );
      
    }

    const onLogout = () => {
      //client.clearStore();
      //logout();
      history.push ("/");
    }


  return (
    
    <div className='settinP'>
        <Button onClick={Promo}> ☀️ Promocionar ☀️  </Button>
        <Button onClick={titulo}> Nonbre del articulo  </Button>
        <Button onClick={Descripcion}> Descripcion </Button>
        <Button onClick={Marcar}>WhastApp </Button>
        <Button onClick={Vide} > Agregar video youtube  </Button>
        <Button onClick={Merca} > Agregar link de Mercado </Button>
        <Button onClick={Maket} > Agregar link de Marketplace </Button>
        <Button onClick={Eliminar} > Borrar publicacion 🗑️ </Button>
        <Button onClick={()=> setShowModal (false)}> Cancelar  </Button>
    </div>
    

     
  
  )
}
